module.exports = __webpack_public_path__ + "img/2_Wawa_Screen_2.0cadf027.jpg";